import { useTranslation } from '@/i18n';
import classnames from 'classnames/bind';
import { FC } from 'react';
import { HeaderSection, SettingItem } from '../Common';
import { OfficeSettingActions } from '../OfficeSettingActions';
import styles from './styles.module.scss';

const cx = classnames.bind(styles);

type AiAgentMainSettingProps = {
  isEnabled: boolean;
  isEditMode: boolean;
};
export const AiAgentMainSetting: FC<AiAgentMainSettingProps> = ({
  isEnabled,
  isEditMode,
}) => {
  const { t } = useTranslation();

  return (
    <div className={cx('aiAgentsMainSettingContainer')}>
      <HeaderSection
        className={cx('flexRowReverse')}
        actionButton={
          <OfficeSettingActions isEnabled={isEnabled} isDisabled={isEditMode} />
        }
      />
      <div className={cx('aiAgentsMainSettingItems')}>
        <SettingItem
          label={t('ai_agents_setting_main_setting_use_setting_label')}
          value={t(isEnabled ? 'use' : 'not_use')}
        />
      </div>
    </div>
  );
};
